import { memo, useEffect, useState } from "react"
import { BrackyArenaScoreboard } from "./BrackyArenaScoreboard"
import { brackyArenaConfig } from "./data/bracky-arena-config"
import { LandingCTA } from "./LandingCTA"

export const LandingSectionBrackyArena = memo(function LandingSectionBrackyArena({
  fanCount = "72K+",
}: {
  fanCount?: string
} = {}) {
  const { classes } = brackyArenaConfig
  const [isDesktop, setIsDesktop] = useState(typeof window !== "undefined" ? window.innerWidth >= 640 : true)

  // Update device state on resize
  useEffect(() => {
    if (typeof window === "undefined") return

    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 640)
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      {/* Scoreboard */}
      <div className={classes.section}>
        <BrackyArenaScoreboard fanCount={fanCount} />
      </div>

      {/* Arena CTA - positioned below scoreboard */}
      <div className="flex flex-col items-center mt-8 sm:mt-12 md:mt-16">
        <div className="*:mb-0!">
          <LandingCTA
            variant="inline"
            label={isDesktop ? ("Enter the Global Arena" as string | undefined) : undefined}
          />
        </div>
        <p className="hidden sm:block mt-4 text-xs sm:text-sm text-white/50 text-center transition-opacity duration-300 ease-out">
          Sign in with X—Start betting live in seconds
        </p>
      </div>
    </>
  )
})
